// extracted by mini-css-extract-plugin
export var dataCell = "_kz-2";
export var dataRow = "_kz-0";
export var headerRow = "_kz-1";